var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialtokensBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0ZM9.2.779h1.551V2.33H9.2ZM16.984,10A6.984,6.984,0,1,1,10,3.016,6.992,6.992,0,0,1,16.984,10ZM4.028,2.931l1.1,1.1-1.1,1.1-1.1-1.1ZM2.3,10.776H.75V9.224H2.3Zm1.727,6.293-1.1-1.1,1.1-1.1,1.1,1.1Zm6.719,2.152H9.2V17.67h1.551Zm5.225-2.152-1.1-1.1,1.1-1.1,1.1,1.1Zm0-11.944-1.1-1.1,1.1-1.1,1.1,1.1Zm1.669,5.651V9.224h1.551v1.551Z",
    fill: "#268AF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50,55.422A5.424,5.424,0,1,0,55.423,50,5.43,5.43,0,0,0,50,55.422Zm5.422,3.055L52.84,55.446l2.581-3.032L58,55.446Z",
    transform: "translate(-45.423 -45.422)",
    fill: "#268AF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialtokensBlue);
export default __webpack_public_path__ + "static/media/socialtokensBlue.22a93e484ec3ae705e4d6068eb260630.svg";
export { ForwardRef as ReactComponent };